/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Payout
 * Payout application
 * OpenAPI spec version: 1.0
 */
import { useQuery } from '@tanstack/react-query';
import {
    type DataTag,
    type DefinedInitialDataOptions,
    type DefinedUseQueryResult,
    type QueryClient,
    type QueryFunction,
    type QueryKey,
    type UndefinedInitialDataOptions,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';
import { payinKyMutator } from '../../shared/api/kyMutator';
import { type ErrorType } from '../../shared/api/kyMutator';
import {
    type GoogleRpcStatus,
    type PayinTraderOrderV1AppealOrderRequest,
    type PayinTraderOrderV1AppealOrderResponse,
    type PayinTraderOrderV1AskProofsOrderRequest,
    type PayinTraderOrderV1AskProofsOrderResponse,
    type PayinTraderOrderV1CancelOrderRequest,
    type PayinTraderOrderV1CancelOrderResponse,
    type PayinTraderOrderV1ConfirmOrderRequest,
    type PayinTraderOrderV1ConfirmOrderResponse,
    type PayinTraderOrderV1CountOrdersResponse,
    type PayinTraderOrderV1CreateOrderRequest,
    type PayinTraderOrderV1CreateOrderResponse,
    type PayinTraderOrderV1GetOrderCheckResponse,
    type PayinTraderOrderV1GetOrderResponse,
    type PayinTraderOrderV1ListOrdersResponse,
    type TraderPayinOrderServiceCountOrdersParams,
    type TraderPayinOrderServiceGetOrderCheckParams,
    type TraderPayinOrderServiceGetOrderParams,
    type TraderPayinOrderServiceListOrdersParams,
} from './model';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить ордер по ID.
 */
export const getTraderPayinOrderServiceGetOrderUrl = (params?: TraderPayinOrderServiceGetOrderParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order?${stringifiedParams}` : '/v1/order';
};

export const traderPayinOrderServiceGetOrder = async (
    params?: TraderPayinOrderServiceGetOrderParams,
    options?: RequestInit,
): Promise<PayinTraderOrderV1GetOrderResponse> => {
    return payinKyMutator<PayinTraderOrderV1GetOrderResponse>(getTraderPayinOrderServiceGetOrderUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayinOrderServiceGetOrderQueryKey = (params?: TraderPayinOrderServiceGetOrderParams) => {
    return ['/v1/order', ...(params ? [params] : [])] as const;
};

export const getTraderPayinOrderServiceGetOrderQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayinOrderServiceGetOrderQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>> = ({ signal }) =>
        traderPayinOrderServiceGetOrder(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayinOrderServiceGetOrderQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>
>;
export type TraderPayinOrderServiceGetOrderQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayinOrderServiceGetOrderParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить ордер по ID.
 */

export function useTraderPayinOrderServiceGetOrder<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrder>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayinOrderServiceGetOrderQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Открыть спор с поддержкой.
Доступно для trader order в статусах STATUS_MERCHANT_CONFIRMED,
STATUS_WAITING_FOR_PROOFS и STATUS_WAITING_PROOFS_APPROVAL.
Ордер переходит в статус STATUS_ON_INVESTIGATION.
 */
export const getTraderPayinOrderServiceAppealOrderUrl = () => {
    return '/v1/order/appeal';
};

export const traderPayinOrderServiceAppealOrder = async (
    payinTraderOrderV1AppealOrderRequest: PayinTraderOrderV1AppealOrderRequest,
    options?: RequestInit,
): Promise<PayinTraderOrderV1AppealOrderResponse> => {
    return payinKyMutator<PayinTraderOrderV1AppealOrderResponse>(getTraderPayinOrderServiceAppealOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinTraderOrderV1AppealOrderRequest),
    });
};

/**
 * @summary Запросить у мерчанта подтверждение перевода.
Доступно для trader order в статусе STATUS_MERCHANT_CONFIRMED.
Ордер переходит в статус STATUS_WAITING_FOR_PROOFS.
 */
export const getTraderPayinOrderServiceAskProofsOrderUrl = () => {
    return '/v1/order/ask_proofs';
};

export const traderPayinOrderServiceAskProofsOrder = async (
    payinTraderOrderV1AskProofsOrderRequest: PayinTraderOrderV1AskProofsOrderRequest,
    options?: RequestInit,
): Promise<PayinTraderOrderV1AskProofsOrderResponse> => {
    return payinKyMutator<PayinTraderOrderV1AskProofsOrderResponse>(getTraderPayinOrderServiceAskProofsOrderUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinTraderOrderV1AskProofsOrderRequest),
    });
};

/**
 * @summary Отменить ордер. Доступно только в статусе STATUS_CREATED.
 */
export const getTraderPayinOrderServiceCancelOrderUrl = () => {
    return '/v1/order/cancel';
};

export const traderPayinOrderServiceCancelOrder = async (
    payinTraderOrderV1CancelOrderRequest: PayinTraderOrderV1CancelOrderRequest,
    options?: RequestInit,
): Promise<PayinTraderOrderV1CancelOrderResponse> => {
    return payinKyMutator<PayinTraderOrderV1CancelOrderResponse>(getTraderPayinOrderServiceCancelOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinTraderOrderV1CancelOrderRequest),
    });
};

/**
 * @summary Получить чек по ордеру при наличии.
 */
export const getTraderPayinOrderServiceGetOrderCheckUrl = (params?: TraderPayinOrderServiceGetOrderCheckParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/order/check?${stringifiedParams}` : '/v1/order/check';
};

export const traderPayinOrderServiceGetOrderCheck = async (
    params?: TraderPayinOrderServiceGetOrderCheckParams,
    options?: RequestInit,
): Promise<PayinTraderOrderV1GetOrderCheckResponse> => {
    return payinKyMutator<PayinTraderOrderV1GetOrderCheckResponse>(getTraderPayinOrderServiceGetOrderCheckUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayinOrderServiceGetOrderCheckQueryKey = (
    params?: TraderPayinOrderServiceGetOrderCheckParams,
) => {
    return ['/v1/order/check', ...(params ? [params] : [])] as const;
};

export const getTraderPayinOrderServiceGetOrderCheckQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderCheckParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayinOrderServiceGetOrderCheckQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>> = ({ signal }) =>
        traderPayinOrderServiceGetOrderCheck(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayinOrderServiceGetOrderCheckQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>
>;
export type TraderPayinOrderServiceGetOrderCheckQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayinOrderServiceGetOrderCheck<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayinOrderServiceGetOrderCheckParams,
    options: {
        query: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>, TError, TData>
        > &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceGetOrderCheck<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderCheckParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceGetOrderCheck<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderCheckParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить чек по ордеру при наличии.
 */

export function useTraderPayinOrderServiceGetOrderCheck<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceGetOrderCheckParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceGetOrderCheck>>, TError, TData>
        >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayinOrderServiceGetOrderCheckQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Подтвердить выполнение ордера.
Доступно для trader order в статусах STATUS_MERCHANT_CONFIRMED,
STATUS_WAITING_FOR_PROOFS и STATUS_WAITING_PROOFS_APPROVAL.
Ордер переходит в статус STATUS_TRADER_CONFIRMED.
 */
export const getTraderPayinOrderServiceConfirmOrderUrl = () => {
    return '/v1/order/confirm';
};

export const traderPayinOrderServiceConfirmOrder = async (
    payinTraderOrderV1ConfirmOrderRequest: PayinTraderOrderV1ConfirmOrderRequest,
    options?: RequestInit,
): Promise<PayinTraderOrderV1ConfirmOrderResponse> => {
    return payinKyMutator<PayinTraderOrderV1ConfirmOrderResponse>(getTraderPayinOrderServiceConfirmOrderUrl(), {
        ...options,
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinTraderOrderV1ConfirmOrderRequest),
    });
};

/**
 * @summary Посмотреть список ордеров по фильтру.
 */
export const getTraderPayinOrderServiceListOrdersUrl = (params?: TraderPayinOrderServiceListOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : v.toString());
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/orders?${stringifiedParams}` : '/v1/orders';
};

export const traderPayinOrderServiceListOrders = async (
    params?: TraderPayinOrderServiceListOrdersParams,
    options?: RequestInit,
): Promise<PayinTraderOrderV1ListOrdersResponse> => {
    return payinKyMutator<PayinTraderOrderV1ListOrdersResponse>(getTraderPayinOrderServiceListOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayinOrderServiceListOrdersQueryKey = (params?: TraderPayinOrderServiceListOrdersParams) => {
    return ['/v1/orders', ...(params ? [params] : [])] as const;
};

export const getTraderPayinOrderServiceListOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayinOrderServiceListOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>> = ({ signal }) =>
        traderPayinOrderServiceListOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayinOrderServiceListOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>
>;
export type TraderPayinOrderServiceListOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayinOrderServiceListOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>, TError, TData>> &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Посмотреть список ордеров по фильтру.
 */

export function useTraderPayinOrderServiceListOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceListOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceListOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayinOrderServiceListOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}

export const getTraderPayinOrderServiceCreateOrderUrl = () => {
    return '/v1/orders';
};

export const traderPayinOrderServiceCreateOrder = async (
    payinTraderOrderV1CreateOrderRequest: PayinTraderOrderV1CreateOrderRequest,
    options?: RequestInit,
): Promise<PayinTraderOrderV1CreateOrderResponse> => {
    return payinKyMutator<PayinTraderOrderV1CreateOrderResponse>(getTraderPayinOrderServiceCreateOrderUrl(), {
        ...options,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', ...options?.headers },
        body: JSON.stringify(payinTraderOrderV1CreateOrderRequest),
    });
};

/**
 * @summary Узнать количество ордеров по фильтру.
 */
export const getTraderPayinOrderServiceCountOrdersUrl = (params?: TraderPayinOrderServiceCountOrdersParams) => {
    const normalizedParams = new URLSearchParams();

    Object.entries(params || {}).forEach(([key, value]) => {
        const explodeParameters = [
            'filter.statuses',
            'filter.publicStatuses',
            'filter.requisiteSuffixes',
            'filter.currency',
        ];

        if (Array.isArray(value) && explodeParameters.includes(key)) {
            value.forEach((v) => {
                normalizedParams.append(key, v === null ? 'null' : v.toString());
            });

            return;
        }

        if (value !== undefined) {
            normalizedParams.append(key, value === null ? 'null' : value.toString());
        }
    });

    const stringifiedParams = normalizedParams.toString();

    return stringifiedParams.length > 0 ? `/v1/orders/count?${stringifiedParams}` : '/v1/orders/count';
};

export const traderPayinOrderServiceCountOrders = async (
    params?: TraderPayinOrderServiceCountOrdersParams,
    options?: RequestInit,
): Promise<PayinTraderOrderV1CountOrdersResponse> => {
    return payinKyMutator<PayinTraderOrderV1CountOrdersResponse>(getTraderPayinOrderServiceCountOrdersUrl(params), {
        ...options,
        method: 'GET',
    });
};

export const getTraderPayinOrderServiceCountOrdersQueryKey = (params?: TraderPayinOrderServiceCountOrdersParams) => {
    return ['/v1/orders/count', ...(params ? [params] : [])] as const;
};

export const getTraderPayinOrderServiceCountOrdersQueryOptions = <
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
) => {
    const { query: queryOptions, request: requestOptions } = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getTraderPayinOrderServiceCountOrdersQueryKey(params);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>> = ({ signal }) =>
        traderPayinOrderServiceCountOrders(params, { signal, ...requestOptions });

    return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
        Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
        TError,
        TData
    > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TraderPayinOrderServiceCountOrdersQueryResult = NonNullable<
    Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>
>;
export type TraderPayinOrderServiceCountOrdersQueryError = ErrorType<GoogleRpcStatus>;

export function useTraderPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params: undefined | TraderPayinOrderServiceCountOrdersParams,
    options: {
        query: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>, TError, TData>> &
            Pick<
                DefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<
            UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>, TError, TData>
        > &
            Pick<
                UndefinedInitialDataOptions<
                    Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
                    TError,
                    Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>
                >,
                'initialData'
            >;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTraderPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Узнать количество ордеров по фильтру.
 */

export function useTraderPayinOrderServiceCountOrders<
    TData = Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>,
    TError = ErrorType<GoogleRpcStatus>,
>(
    params?: TraderPayinOrderServiceCountOrdersParams,
    options?: {
        query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof traderPayinOrderServiceCountOrders>>, TError, TData>>;
        request?: SecondParameter<typeof payinKyMutator>;
    },
    queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
    const queryOptions = getTraderPayinOrderServiceCountOrdersQueryOptions(params, options);

    const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
        queryKey: DataTag<QueryKey, TData, TError>;
    };

    return { ...query, queryKey: queryOptions.queryKey };
}
